import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './Login.css';
import api from '../../utils/api.service';
import { ENDPOINTS } from '../../utils/api-config';

const Login = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await api.post(ENDPOINTS.AUTH.LOGIN, formData);
      const loginData = response.data || response;
      const token = loginData.accessToken || loginData.access_token;
      
      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(loginData.user));
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
        navigate('/dashboard');
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (err) {
      if (err.code === 'ECONNABORTED' || !err.response) {
        setError('Server is taking too long to respond. It might be starting up. Please try again in a few seconds.');
      } else {
        setError(err.response?.data?.message || 'Unauthorized. Access restricted to authorized personnel.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-illustration">
          <div className="illustration-overlay">
            <div className="floating-circle circle-1"></div>
            <div className="floating-circle circle-2"></div>
            <div className="floating-circle circle-3"></div>
          </div>
          <div className="illustration-content">
            <div className="silhouette-group">
              <div className="silhouette parent"></div>
              <div className="silhouette child"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-container">
          <div className="login-header">
            {/* <h1>Welcome to TinyCare Admin</h1> */}
            <div className="brand-logo">
              <div className="brand-logo-image-container">
                <img src="/logo192.png" alt="TinyCare Logo" className="brand-logo-img" />
              </div>
              <span className="brand-text">TinyCare</span>
            </div>
          </div>

          <h2 className="form-title">Admin Login</h2>
          <p className="form-subtitle">Sign in to access the TinyCare management console</p>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  style={{width: '100%'}}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your security password"
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <small className="form-hint">This portal is restricted to authorized staff only</small>
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            {/* <div className="demo-hint">
              <p><strong>Demo Login:</strong></p>
              <p>Email: <code>admin@tinycare.com</code></p>
              <p>Password: <code>admin123</code></p>
            </div> */}

            <button type="submit" className="btn-signin" disabled={loading}>
              {loading ? 'Signing In...' : 'Sign In'}
            </button>

            <Link to="/forgot-password" size="small" className="forgot-link">Forgot password?</Link>
          </form>

          <div className="login-footer">
            <p>© TinyCare. All rights reserved.</p>
            <p className="footer-description">
              Manage bookings, providers, customers, payments, and platform operations from one place.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;